module.exports = __webpack_public_path__ + "img/DSC_1153.669785d1.jpg";